"use strict";
"use client";
import { chakra } from '../../styled-system/factory.js';

const Box = chakra("div");
Box.displayName = "Box";

export { Box };
